import { render, staticRenderFns } from "./personInfoList.vue?vue&type=template&id=9ac99248&scoped=true"
import script from "./personInfoList.vue?vue&type=script&lang=js"
export * from "./personInfoList.vue?vue&type=script&lang=js"
import style0 from "./personInfoList.vue?vue&type=style&index=0&id=9ac99248&prod&lang=scss"
import style1 from "./personInfoList.vue?vue&type=style&index=1&id=9ac99248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac99248",
  null
  
)

export default component.exports